import React from 'react'

export const radioUnchecked = ({ width, height, fill, theme: { color } }) => (
  <svg width={width || 16} height={height || 16} fill="none" viewBox="0 0 16 16">
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill={fill || color.general.lightest} />
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke={color.general.light} />
  </svg>
)
